var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:!_vm.disabled ? _vm.primary && 'primary' : 'disabled',on:{"click":function($event){!_vm.disabled ? _vm.$emit('click') : ''}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }